// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#pretreat-loader { animation: pretreat-loader 0.75s infinite linear; }

@keyframes pretreat-loader {
  from { transform: rotate(0deg); }
  to { transform: rotate(359.999999999999999deg); }
}

.fluoride-loading {
  color: transparent !important;
  transition: opacity 0.3s;
  opacity: 0.5;
}`, "",{"version":3,"sources":["webpack://./src/css/styles.css"],"names":[],"mappings":"AAAA,mBAAmB,gDAAgD,EAAE;;AAErE;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yCAAyC,EAAE;AAClD;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,YAAY;AACd","sourcesContent":["#pretreat-loader { animation: pretreat-loader 0.75s infinite linear; }\n\n@keyframes pretreat-loader {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(359.999999999999999deg); }\n}\n\n.fluoride-loading {\n  color: transparent !important;\n  transition: opacity 0.3s;\n  opacity: 0.5;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
